import React, { useState } from 'react';
import { Trans } from '@lingui/react';
import Styled from 'styled-components';
import truncate from 'truncate-html';
import { Element } from 'react-scroll';
import Divider from '@components/Divider';
import Icon from '@components/Icon';
import { MetaBox } from '@ecosystems/programs/single/components';
import { Box, Flex } from '@components/layout/Grid';
import { ProgramIntroductionStyles } from '@components/texts';
import ProgramCollapsibleTitle from '@components/ProgramCollapsibleTitle';
import Button from '@components/buttons';
import { GenericProgram } from '@gql/generated';
import { ProgramIntroFieldsFragment } from '@gql/generated';

const ProgramIntroductionText = Styled(ProgramIntroductionStyles)`
  h2 {
    font-size: 20px;
  }
    
  p > strong:first-of-type {
    display: inline-block;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  p strong:empty {
    display: none;
  }
`;

type Props = {
  programCategory?: GenericProgram['category'];
  data: ProgramIntroFieldsFragment;
  weeksCount: number | string;
  videosCount: number | string;
  isOpen: boolean;
  onOpen(): void;
  onClose(): void;
  programDuration?: React.ReactNode;
  'data-testid'?: string;
};

const PhasedProgramIntroductionCollapsable = (props: Props) => {
  const {
    data,
    videosCount,
    isOpen,
    onOpen,
    onClose,
    programCategory,
    'data-testid': dataTestId,
    programDuration = null,
  } = props;

  // const theme = useTheme();
  const [showMore, setShowMore] = useState(false);
  const truncatedContent = truncate(data.description, 100, {
    byWords: true,
  });

  const handleClick = (e) => {
    if (e.target instanceof HTMLAnchorElement) {
      // its either this or we manually update the DOM
      // which will be tricky because we have a collapsable and not all elements will be visible initially...
      e.preventDefault();
      window.open(e.target.href);
    }
  };

  return (
    <ProgramCollapsibleTitle
      title={() => data.label}
      onOpen={onOpen}
      onClose={onClose}
      isOpen={isOpen}
      appearance={programCategory}
      data-testid={dataTestId}
    >
      <Element name="introduction">
        <React.Fragment>
          {showMore ? (
            <ProgramIntroductionText
              key="showMore"
              className="embeddedText"
              onClick={handleClick}
              dangerouslySetInnerHTML={{
                __html: data.description,
              }}
            />
          ) : (
            <ProgramIntroductionText
              key="showLess"
              onClick={handleClick}
              className="embeddedText"
              dangerouslySetInnerHTML={{
                __html: truncatedContent,
              }}
            />
          )}
          {data.description?.length > 100 ? (
            <Box my={20}>
              <Button
                appearance="outline"
                onClick={() => setShowMore(!showMore)}
              >
                {showMore ? (
                  <Trans
                    id="campaign_info.read_less"
                    message="Dölj text"
                  ></Trans>
                ) : (
                  <Trans
                    id="campaign_info.read_more"
                    message="Visa mer"
                  ></Trans>
                )}
              </Button>
            </Box>
          ) : null}
          <Flex mx="-10px" flexWrap="wrap" mt={30}>
            {programDuration ? (
              <Box
                width={[1 / 2, 1 / 2, 'auto']}
                mb={['10px', '10px', '0px']}
                px="10px"
              >
                <MetaBox appearance={programCategory}>
                  <Box mb="10px">
                    <Icon name="ygb-icon-calendar-o" fontSize="32px" />
                  </Box>
                  <Box>{programDuration}</Box>
                </MetaBox>
              </Box>
            ) : null}
            <Box
              width={[1 / 2, 1 / 2, 'auto']}
              mb={['10px', '10px', '0px']}
              px="10px"
            >
              <MetaBox appearance={programCategory}>
                <Box mb="10px">
                  <Icon name="ygb-icon-playlist" fontSize="32px" />
                </Box>
                <Box>
                  <Trans
                    id={'program.videosTotal'}
                    message={'{videoCount} videos in total'}
                    values={{
                      videoCount: videosCount,
                    }}
                  />
                </Box>
              </MetaBox>
            </Box>
            {/* <Box
                width={[1 / 2, 1 / 2, 'auto']}
                mb={['10px', '10px', '0px']}
                px="10px"
              >
                <MetaBox appearance={appearance}>
                  <Box mb="10px">
                    <DescriptionIcon fontSize="large" />
                  </Box>
                  <Box>
                    <Trans
                      id={'program.videosTotal'}
                      defaults={'{videoCount} videos in total'}
                      values={{
                        videoCount: documentsCount,
                      }}
                    />
                  </Box>
                </MetaBox>
              </Box> */}
            {/* <Box
                width={[1 / 2, 1 / 2, 'auto']}
                mb={['10px', '10px', '0px']}
                px="10px"
              >
                <MetaBox appearance={appearance}>
                  <Box mb="10px">
                    <Icon
                      name="ygb-icon-quiz-ic"
                      fontSize="32px"
                      
                    />
                  </Box>
                  <Box>
                    <Trans
                      id={'program.videosTotal'}
                      defaults={'{quizCount} videos in total'}
                      values={{
                        quizCount: quizesCount,
                      }}
                    />
                  </Box>
                </MetaBox>
              </Box> */}
          </Flex>
          <Box my="30px">
            <Divider />
          </Box>
        </React.Fragment>
      </Element>
    </ProgramCollapsibleTitle>
  );
};

export default PhasedProgramIntroductionCollapsable;
